{
  "title": "Gerir Motoristas",
  "statusUpdated": "Estado do motorista atualizado com sucesso",
  "invitationSent": "Convite enviado com sucesso",
  "resendSuccess": "Convite reenviado com sucesso",
  "search": "Pesquisar",
  "loading": "A carregar motoristas...",
  "name": "Nome",
  "email": "E-mail",
  "status": "Estado",
  "vehiclesColumn": "Veículos",
  "actions": "Ações",
  "deactivate": "Desativar",
  "activate": "Ativar",
  "invitations": "Convites",
  "inviteNewDriver": "Convidar Motorista",
  "loadingInvitations": "A carregar convites...",
  "noInvitations": "Sem convites pendentes.",
  "invitePending": "Convite pendente.",
  "resend": "Reenviar",
  "of": "de",
  "statusLabels": {
    "active": "Ativo",
    "inactive": "Inativo",
    "new": "Novo",
    "deactivated": "Desativado",
    "covered": "Cobertura ativa",
    "awaitingCoverage": "A aguardar cobertura",
    "awaitingLicense": "A aguardar licença",
    "associated": "Associado",
    "pending": "Pendente",
    "invited": "Convidado"
  },
  "statusTabs": {
    "all": "Todos",
    "archived": "Inativo"
  },
  "funding": {
    "company": "Empresa paga",
    "self": "Licença própria",
    "ambiguous": "Por confirmar",
    "uncovered": "Sem cobertura",
    "hidden": "Ocultos",
    "covered": "Cobertura ativa",
    "awaiting": "A aguardar cobertura",
    "notCovered": "Sem cobertura ativa",
    "associated": "Associado à empresa",
    "deactivated": "Associação desativada",
    "relationship": "Estado do vínculo",
    "summaryTitle": "Licença e financiamento",
    "relationshipLabel": "Vínculo com a empresa",
    "payerLabel": "Licença paga por",
    "coverageLabel": "Cobertura",
    "personalCoverageLabel": "Cobertura própria",
    "companyCoverageLabel": "Cobertura da empresa",
    "corporateSeatUseLabel": "Utilização das vagas da empresa",
    "relationshipStates": {
      "active": "Ativo",
      "associated": "Associado à empresa",
      "pending": "Pendente",
      "deactivated": "Desativado",
      "unknown": "Desconhecido"
    },
    "payers": {
      "company": "Empresa",
      "self": "Motorista (self-pay)",
      "ambiguous": "Por confirmar",
      "uncovered": "Sem pagador ativo",
      "unknown": "Desconhecido"
    },
    "compactStatuses": {
      "active": "Ativo",
      "awaiting": "A aguardar licença",
      "pending": "Pendente",
      "deactivated": "Desativado",
      "notCovered": "Sem licença ativa",
      "associated": "Associado",
      "unknown": "Desconhecido"
    },
    "compactPayers": {
      "company": "Empresa paga",
      "self": "Self-pay",
      "ambiguous": "Por confirmar",
      "uncovered": "Sem pagador ativo",
      "unknown": "Desconhecido"
    },
    "coverageStates": {
      "active": "Ativa",
      "awaiting": "A aguardar cobertura",
      "not_covered": "Sem cobertura ativa",
      "unknown": "Desconhecida"
    },
    "corporateSeatUse": {
      "self": "0 — licença própria; não utiliza vaga da empresa",
      "none": "0 — não utiliza vaga da empresa",
      "company_one": "{{count}} vaga da empresa",
      "company_other": "{{count}} vagas da empresa",
      "ambiguous": "{{count}} — por confirmar; incluída na utilização da empresa",
      "uncovered": "0 — sem cobertura ativa",
      "unknown": "Desconhecida"
    },
    "licenseIssues": {
      "paymentOverdue": "Pagamento em atraso",
      "canceledNonpayment": "Cancelada — pagamento falhou",
      "paymentOverdueAction": "{{name}} não consegue registar trabalho até o pagamento ser regularizado. Peça-lhe para atualizar o método de pagamento, ou envie-lhe um novo convite pago pela empresa em Motoristas.",
      "canceledNonpaymentAction": "{{name}} deixou de poder registar trabalho. Peça-lhe para ativar uma nova licença, ou envie-lhe um novo convite pago pela empresa em Motoristas.",
      "thisDriver": "Este motorista"
    }
  },
  "filters": {
    "title": "Filtros",
    "search": "Pesquisar",
    "status": "Estado do vínculo",
    "payer": "Licença paga por",
    "visibility": "Visibilidade nos relatórios",
    "showHidden": "Mostrar condutores ocultos dos relatórios",
    "showMore": "Mais filtros",
    "showFewer": "Menos filtros",
    "needsAttention": "Requer atenção",
    "dataToConfirm": "Dados por confirmar",
    "noActiveLicense": "Sem licença ativa",
    "sort": "Ordenar por",
    "licensePaymentIssue": "Pagamento da licença falhou"
  },
  "newest": "Mais Recente",
  "oldest": "Mais Antigo",
  "az": "A-Z",
  "za": "Z-A",
  "sortByDate": "Data",
  "sortByName": "Nome",
  "sortLabel": "Ordenar por",
  "noResults": "Sem resultados",
  "page": "Página",
  "showing": "A mostrar",
  "drivers": "motoristas",
  "registrationDate": "Registo",
  "activated": "Ativado",
  "deactivated": "Desativado",
  "common": {
    "all": "Todos",
    "status": "Estado",
    "previous": "Anterior",
    "next": "Seguinte",
    "ok": "OK",
    "cancel": "Cancelar"
  },
  "ownerDashboard": {
    "inviteDriver": "Convidar Motorista"
  },
  "error": "Erro",
  "errorFetchingDrivers": "Erro ao obter motoristas",
  "errorUpdatingStatus": "Erro ao atualizar o estado do motorista",
  "errorSendingInvitation": "Erro ao enviar convite",
  "errorResendingInvitation": "Erro ao reenviar convite",
  "errorFetchingInvitations": "Erro ao obter convites",
  "errorCancelingInvitation": "Erro ao cancelar convite",
  "noDriversFound": "Nenhum motorista encontrado",
  "invitationsPending": "pendentes",
  "expired": "Expirado",
  "expiresToday": "Expira hoje",
  "expiresTomorrow": "Expira amanhã",
  "expiresInDays": "Expira em {{days}} dias",
  "expiresAt": "Expira em",
  "pending": "Pendente",
  "workStartDate": "Data de início de trabalho",
  "driverDetailsTitle": "Detalhes do Motorista",
  "driverDetails": {
    "personalInfo": "Informações Pessoais",
    "employmentInfo": "Informações de Emprego",
    "phoneNumber": "Número de Telefone",
    "address": "Morada",
    "licenseNumber": "CMTVDE",
    "workStartDate": "Data de Início da Prestação do Trabalho",
    "startDate": "Data de Início na Empresa",
    "status": "Estado",
    "updatingStatus": "A atualizar estado...",
    "emailVerified": "O e-mail está verificado. Não pode ser alterado.",
    "emailUnverified": "O e-mail não está verificado. Pode alterá-lo, mas será necessária verificação.",
    "reportExportTitle": "Relatório semanal de horas",
    "reportExportDescription": "Exporte o relatório semanal de horas do motorista selecionado em PDF. A data de início da semana é a segunda-feira atual por predefinição.",
    "weekStart": "Início da semana",
    "exportHoursReportPdf": "Exportar relatório de horas (PDF)",
    "exportError": "Erro ao exportar o relatório semanal de horas.",
    "exportShareUnavailable": "A partilha não está disponível neste dispositivo.",
    "shareReportTitle": "Partilhar relatório semanal de horas",
    "reportHidden": "Oculto dos relatórios da empresa",
    "reportHiddenDescription": "É reversível. Motoristas ocultos exigem inclusão explícita nas exportações.",
    "hiddenExportIncluded": "Esta exportação incluirá explicitamente o motorista oculto.",
    "reportHiddenError": "Erro ao atualizar a visibilidade nos relatórios.",
    "relationshipControlTitle": "Vínculo com a empresa",
    "relationshipActivationLabel": "Ativação pela empresa",
    "selfPaySummary": "Paga pelo condutor · Sem vaga da empresa"
  },
  "vehicles": {
    "allVehicles": "Todos os Veículos",
    "allDrivers": "Todos os Motoristas",
    "searchVehicles": "Pesquisar por matrícula, marca, modelo ou ano...",
    "searchDrivers": "Pesquisar motoristas...",
    "assignedTo": "Atribuído a:",
    "assignedVehicles": "Veículos atribuídos:",
    "assigned": "Atribuído",
    "dropHereToAssign": "Largue aqui para atribuir!",
    "dragToAssign": "Arraste para atribuir ou largue aqui",
    "selectVehicle": "Selecione um veículo para atribuir",
    "assignToDriver": "Atribuir ao Motorista",
    "unassignFromDriver": "Desatribuir",
    "editVehicle": "Editar Veículo",
    "addVehicle": "Adicionar Veículo",
    "vehicleAssigned": "Veículo atribuído com sucesso",
    "vehicleUnassigned": "Veículo desatribuído com sucesso",
    "vehicleCreated": "Veículo criado com sucesso",
    "vehicleUpdated": "Veículo atualizado com sucesso",
    "errorAssigningVehicle": "Erro ao atribuir veículo",
    "errorUnassigningVehicle": "Erro ao desatribuir veículo",
    "errorSavingVehicle": "Erro ao guardar veículo",
    "vehicleAlreadyExistsInCompany": "Este veículo já pertence à sua empresa.",
    "vehicleAssociatedWithCompany": "Veículo foi associado à sua empresa.",
    "errorAssociatingVehicle": "Erro ao associar veículo à empresa.",
    "registrationNumberError": "Formato de número de registo inválido.",
    "noVehiclesSelected": "Nenhum veículo selecionado",
    "assignmentMethods": "Métodos de Atribuição:",
    "dragInstructions": "Para atribuir, arraste o cartão do veículo para o do motorista (ou vice-versa). Como alternativa, clique no cartão para selecioná-lo e depois clique em 'Associar'.",
    "assignSelected": "Atribuir Selecionados",
    "previous": "Anterior",
    "next": "Seguinte",
    "registrationNumber": "Número de Registo",
    "make": "Marca",
    "model": "Modelo",
    "year": "Ano",
    "fuelType": "Tipo de Combustível",
    "dragToAssignDriver": "💡 Arraste para atribuir ou largue um motorista aqui",
    "dragToAssignVehicle": "💡 Arraste para atribuir ou largue um veículo aqui",
    "noVehicles": "Nenhum veículo adicionado ainda.",
    "addFirstVehicle": "Adicionar Primeiro Veículo",
    "moreVehicles": "+{count} veículos a mais",
    "assignAVehicle": "Atribuir um Veículo",
    "update": "Atualizar",
    "create": "Criar",
    "manageVehicles": "Gerir Veículos",
    "totalVehicles": "Veículos",
    "unassigned": "Não atribuídos",
    "availableVehicles": "Veículos Disponíveis",
    "noVehiclesMatchSearch": "Nenhum veículo corresponde à sua pesquisa",
    "allVehiclesAssigned": "Todos os veículos estão atribuídos a este motorista",
    "assign": "Atribuir",
    "assignVehicles": "Atribuir Veículos",
    "selected": "selecionado",
    "select": "Selecionar",
    "noVehiclesFound": "Nenhum veículo encontrado que corresponda à sua pesquisa",
    "noAvailableVehicles": "Nenhum veículo disponível para atribuir",
    "noDetails": "Sem detalhes adicionais",
    "selectAtLeastOne": "Por favor, selecione pelo menos um veículo",
    "loadError": "Não foi possível carregar os veículos",
    "assignError": "Erro ao atribuir veículos",
    "noAssignedVehicles": "Nenhum veículo atribuído",
    "delete": "Eliminar",
    "remove": "Remover",
    "confirmRemove": "Remover Veículo da Empresa",
    "removeMessage": "Tem a certeza de que deseja remover o veículo {{registration}} da sua empresa? O veículo permanecerá na base de dados, mas deixará de estar associado à sua empresa.",
    "vehicleRemoved": "Veículo removido da empresa com sucesso",
    "errorRemovingVehicle": "Erro ao remover veículo da empresa"
  },
  "transfers": {
    "title": "Solicitações de Transferência",
    "pendingTransfers": "Transferências Pendentes",
    "loading": "A carregar transferências...",
    "noRequests": "Sem solicitações pendentes",
    "approve": "Aprovar",
    "reject": "Rejeitar",
    "approveSuccess": "Transferência aprovada com sucesso",
    "rejectSuccess": "Transferência rejeitada",
    "errorApproving": "Erro ao aprovar transferência",
    "errorRejecting": "Erro ao rejeitar transferência",
    "errorFetching": "Erro ao carregar transferências",
    "driverInfo": "Informações do Motorista",
    "currentCompany": "Empresa Atual",
    "reason": "Motivo",
    "requestedAt": "Solicitado em",
    "confirmApprove": "Confirmar Aprovação",
    "confirmReject": "Confirmar Rejeição",
    "approveMessage": "Tem a certeza de que deseja aprovar a transferência de {{name}}? O motorista será automaticamente transferido para a sua empresa.",
    "rejectMessage": "Tem a certeza de que deseja rejeitar a transferência de {{name}}?",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "from": "De",
    "status": {
      "pending": "Pendente",
      "approved": "Aprovado",
      "rejected": "Rejeitado"
    }
  },
  "bulkActions": {
    "selected": "Selecionados: {{count}}",
    "selectAll": "Selecionar Todos",
    "transfer": "Transferir",
    "activate": "Ativar",
    "transferDrivers": "Transferir {{count}} Motoristas",
    "transferDriversDescription": "Selecione a empresa de destino para transferir os motoristas selecionados.",
    "transferResult": "Transferidos {{success}} motorista(s). {{errors}} erro(s).",
    "transferError": "Erro ao transferir motoristas: {{error}}",
    "transferLicenseError": "A empresa de destino não tem licenças de motoristas disponíveis.",
    "activateResult": "Ativados {{success}} motorista(s). {{errors}} erro(s).",
    "activateError": "Erro ao ativar motoristas: {{error}}",
    "noInactiveDrivers": "Nenhum motorista inativo selecionado",
    "noDriversSelected": "Nenhum motorista selecionado",
    "result": "Resultado da Operação",
    "licenseErrors": "Problemas de licença:\n{{errors}}",
    "buyLicensesHint": "Por favor, compre licenças adicionais para ativar mais motoristas. Vá para a página de subscrição para comprar mais licenças.",
    "licenseError": "Precisa de comprar licenças para ativar motoristas.",
    "licenseErrorTitle": "Licenças Necessárias",
    "licenseErrorDescription": "Para ativar este motorista, precisa de comprar licenças de motorista adicionais. Clique no botão abaixo para ir para a página de gestão de licenças.",
    "goToLicenses": "Ir para Licenças"
  },
  "transfer": {
    "alsoTransferVehicles": "Também transferir {{count}} veículos relacionados",
    "alsoTransferDrivers": "Também transferir {{count}} motoristas relacionados",
    "selectCompany": "Por favor, selecione uma empresa de destino",
    "error": "Erro ao transferir",
    "noOtherCompanies": "Precisa de pelo menos uma outra empresa para transferir.",
    "errorLoadingCompanies": "Erro ao carregar empresas",
    "transferButton": "Transferir",
    "licenseError": "A empresa de destino não tem licenças de motoristas disponíveis."
  }
}
